import { Navigate } from 'react-router-dom';
import { usePathologist } from '../hook/usePathologist';
const PathologistRoute = ({ component: Component, ...rest }) => {
  const { isPathologist,isAdmin,isSuperAdmin, isHospitalManager, isLoading } = usePathologist();
  // console.log("usePathologist isPathologist:", isPathologist);
  // console.log("usePathologist isAdmin:", isAdmin);    
  // console.log("usePathologist isSuperAdmin:", isSuperAdmin);
  
  if (isLoading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  
  return (isPathologist||isAdmin||isSuperAdmin||isHospitalManager) ? <Component {...rest} /> : <Navigate to="/login" replace />;
};

export default PathologistRoute;